import React from "react";
import { Link } from "react-router-dom";
import { Heart, Stethoscope } from "lucide-react";

function SummaryBanner() {
  const cards = [
    {
      id: 1,
      title: "ফ্রি মেডিকেল ও রক্তগ্রুপ নির্ণয়",
      description: "বিনামূল্যে চিকিৎসা সেবা ও রক্তগ্রুপ নির্ণয় কর্মসূচি",
      icon: <Stethoscope className="h-full w-full" />,
      buttons: [
        { text: "বিস্তারিত", link: "/projects?tab=medical" },
        { text: "রক্তদাতা হিসেবে নিবন্ধন", link: "/blood-donor-register" },
      ],
    },
  ];

  return (
    <div className="pt-32 mt-10 px-4 w-full">
      {/* Header with decorative elements */}

      <div className="flex flex-col lg:flex-row gap-10 items-stretch">
        {/* Left Content - 1/3 width */}
        <div className="lg:w-1/3 flex">
          <div className="bg-white rounded-lg shadow-lg p-8 lg:p-12 transform transition-all duration-300 hover:shadow-xl w-full flex flex-col justify-center">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
              নিঃস্বার্থ নবজীবন সংগঠন (NNS) একটি{" "}
              <span className="text-primary">স্বপ্নের নাম</span>
            </h1>

            <p className="mb-8 text-gray-700 leading-relaxed text-lg lg:text-xl">
              আমরা চাই ধনী ও গরীবের সমতা। অসহায়, নিঃস্ব, নিপীড়িত ও অনাথ
              পথশিশুরা যেন তাদের মৌলিক অধিকার থেকে বঞ্চিত না হয়, সে বিষয়
              নিশ্চিত করা অর্থাৎ ক্ষুধা ও দরিদ্রমুক্ত সমাজ বিনির্মাণে আমরা
              বদ্ধপরিকর। স্বপ্নবাজ শিশু, কিশোর, তরুণ যারা দেশ এগিয়ে নেওয়ার
              স্বপ্ন দেখে, আমরা চাই টাকার অভাবে যাতে কোন শিক্ষার্থীকে পড়াশোনা
              থেকে ঝড়ে পড়তে না হয়। চিকিৎসার অভাবে যাতে কাউকে মরতে না হয়।
            </p>

            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg text-lg w-fit"
            >
              <Heart className="h-6 w-6" />
              আরো পড়ুন
            </Link>
          </div>
        </div>

        {/* Right Content - 2/3 width with background image */}
        <div className="lg:w-2/3 flex">
          {cards.map((card) => (
            <div
              key={card.id}
              className="relative bg-white rounded-lg shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl hover:translate-y-[-5px] border border-gray-100 w-full flex flex-col"
              data-aos="fade-up"
              data-aos-delay={card.id * 100}
            >
              {/* Background Image */}
              <div
                className="absolute inset-0 bg-[url('/src/assets/image/medical.jpeg')] bg-cover bg-center z-0 rounded-lg "
                aria-hidden="true"
              />

              {/* Minimal overlay for text readability */}
              <div className="absolute bg-black/60 inset-0  z-10 rounded-lg" />

              <div className="relative z-20 p-6 lg:p-8 flex flex-col justify-center flex-grow ">
                <div className="mt-auto">
                  <h2 className="text-2xl lg:text-4xl font-bold text-primary mb-4 text-center">
                    {card.title}
                  </h2>
                  <p className="text-white text-center mb-8 text-lg lg:text-2xl leading-relaxed">
                    {card.description}
                  </p>
                </div>

                <div className="flex justify-center mt-auto">
                  {card.buttons ? (
                    <div className="flex gap-4 w-full max-w-md justify-center">
                      {card.buttons.map((button, index) => (
                        <Link
                          key={index}
                          to={button.link}
                          className="inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-white font-bold py-3 px-6 rounded-lg transition-all duration-300 text-base lg:text-lg flex-1"
                        >
                          {button.text}
                        </Link>
                      ))}
                    </div>
                  ) : (
                    <Link
                      to={card.link}
                      className="inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-white font-bold py-3 px-6 rounded-lg transition-all duration-300 text-base lg:text-lg"
                    >
                      {card.buttonText}
                    </Link>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SummaryBanner;
